<template>
  <div
    class="min-[1140px]:max-w-[1140px] container relative mx-auto bg-transparent"
  >
    <!-- ===================== HERO SECTION ===================== -->
    <section
      id="section1"
      class="hero-section relative mx-auto mt-[150px] flex justify-center gap-1 bg-transparent lg:py-0"
      :style="backgroundImageStyle"
    >
      <div class="z-10 mt-0 bg-transparent px-[25px] text-center xl:px-0">
        <h1
          class="top-full mt-0 px-0 text-[35px] font-extrabold tracking-normal text-[#fff] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
        >
          Access Platforma from everywhere.
        </h1>

        <p
          class="mt-[5px] mb-[25px] text-[15px] font-medium text-[#fff] lg:text-lg"
        >
          Download Platforma on any and every device—mobile, desktop, voice
          assistants, and more
        </p>

        <img
          loading="lazy"
          class="lg:max-w-[1040px]"
          :src="
            $filters.public_path(
              'new/download-platforma-online-course-builder-main-hero.png'
            )
          "
          alt="Download Platforma on any device to manage your membership."
        />
        <!-- <img :src="$filters.media_path('/images/test-img.jpg')" alt="" /> -->
      </div>
    </section>

    <div
      class="mx-[15px] mt-5 flex flex-wrap justify-between gap-2 rounded-[5px] bg-[#2d8bff13] py-[17px] px-[15px] md:mx-auto md:h-[50px] md:w-[725px]"
    >
      <div>
        <img
          :src="
            $filters.media_path(
              '/images/download-page-browser-platforma-icon.svg'
            )
          "
          alt="Download Platforma on any device to manage your membership."
          loading="lazy"
        />
      </div>

      <div>
        <p class="text-xs text-[#7C828D]">
          Use Platforma from any browser to manage your subscription business.
        </p>
      </div>

      <div class="flex">
        <a
          href="https://platformarea.com/creator/login"
          class="text-xs text-[#2d8cff]"
          >Open in Browser</a
        >

        <a href="https://platformarea.com/creator/login">
          <img
            :src="
              $filters.media_path('images/right-arrow-icon-platforma-blue.svg')
            "
            alt="arrows"
            class="mt-[3px] md:ml-[8px]"
        /></a>
      </div>
    </div>
  </div>

  <!-- =======CONTAINER END======== -->

  <!-- =============APP SECTION START============= -->

  <!-- APPS HEADLINES HEADLINES -->

  <section class="mx-[25px] mt-[145px] text-center">
    <div class="text-center">
      <div
        id="text_compare"
        class="text-center text-xs font-bold tracking-wide text-[#2D8CFF]"
      >
        APPS
      </div>

      <h2
        class="px-auto top-full mt-[20px] text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
      >
        Apps for all your devices.
      </h2>

      <p
        class="mt-[20px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-full"
      >
        Access key Platforma features from outside the platform so you can keep
        engaging and never miss a sale.
      </p>
    </div>
  </section>

  <!-- APPS OPTION SECTION -->

  <div
    class="mx-[20px] mt-[65px] max-w-[1180px] justify-between gap-[30px] lg:mx-auto lg:flex"
  >
    <div class="rounded-[15px] bg-[#3e87df10] p-[30px]">
      <img
        :src="$filters.media_path('images/mobile-icon-platforma-blue.svg')"
        alt=""
        class="mb-[25px]"
      />
      <h3 class="mb-[25px] text-[28px] font-bold text-[#292d34]">Mobile</h3>
      <p class="mb-[25px] text-sm text-[#292d34]">Get sales on the go.</p>
      <div class="justify between flex gap-3">
        <img
          :src="
            $filters.media_path('images/apple-app-store-download-button.svg')
          "
          alt=""
        />
        <img
          :src="$filters.media_path('images/google-play-store-button.svg')"
          alt=""
        />
      </div>
    </div>

    <div
      class="desktop-app md:dis rounded-[15px] bg-[#FFC80010] bg-[length:362px_309px] bg-right-bottom bg-no-repeat p-[30px] lg:w-[750px]"
    >
      <img
        :src="$filters.media_path('images/desktop-icon-yellow.svg')"
        alt=""
        class="mb-[25px]"
      />
      <h3 class="mb-[25px] text-[28px] font-bold text-[#292d34]">Desktop</h3>
      <p class="mb-[25px] text-sm text-[#292d34]">
        Convert sales from your desktop.
      </p>

      <div class="justify between flex gap-3">
        <img
          :src="
            $filters.media_path('images/apple-app-store-download-button.svg')
          "
          alt=""
        />
        <img
          :src="$filters.media_path('images/google-play-store-button.svg')"
          alt=""
        />
      </div>
    </div>
  </div>
  <!-- ===================== CTA BLOCK ===================== -->
  <GotQuestionsOneCtaBlockFooterComponent cta-headline="Got Questions" />
</template>

<script>
import DefaultLayout from '../Layouts/DefaultLayout.vue';
import ButtonComponent from '@shared/Components/ButtonComponent.vue';
import Axios from 'axios';
import GotQuestionsOneCtaBlockFooterComponent from '../Components/GotQuestionsOneCtaBlockFooterComponent.vue';

export default {
  layout: DefaultLayout,
  components: {
    ButtonComponent,
    GotQuestionsOneCtaBlockFooterComponent
  },

  computed: {
    backgroundImageStyle() {
      const imagePath = this.$filters.public_path(
        'new/download-platforma-hero-bg.svg'
      );
      return {
        '--before-background-image': `url(${imagePath})`
      };
    }
  }
};
</script>
<style>
.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  height: 589px;
  width: 1700px;
  display: block;
  transform: translateY(-28%);
  background-repeat: no-repeat;
  background-image: var(--before-background-image);
}

.desktop-app {
  background-image: url(../media/images/platforma-creator-ui-download-page-desktop.png);
}

@media screen and (max-width: 768px) {
  .desktop-app {
    background: transparent;
  }
}
</style>
